import { List, Map } from 'immutable';
import getCurrentGroupId from './getCurrentGroupId';
import { toInt10 } from 'helpers/transform';

export default function getLeadStatuses(state: any): Status[] {
  const currentGroupId = getCurrentGroupId(state);
  const statusesById: Map<string, TypedMap<Status>> = state.getIn(
    ['status', 'data', 'byId'],
    Map()
  );
  const statuses: Status[] = state
    .getIn(['status', 'data', 'result'], List())
    .map((id: number) => statusesById.get(id.toString()))
    .toJS();

  return statuses
    .map(status => ({
      ...status,
      groupId: toInt10(status?.groupId || 0),
    }))
    .filter(({ groupId }) => groupId === currentGroupId);
}
